import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
    getIsAppRebrandActive,
    getIsTicketSelectionCompactSizeFlow,
    getWidgetParentUrl,
} from '../../../selectors/app';
import { CheckoutState } from '../../../state';
import type { TicketDisplayCardContentSwitcherProps } from './TicketDisplayCardContentSwitcher';

const _mapStateToProps = (
    state: CheckoutState,
): Pick<
    TicketDisplayCardContentSwitcherProps,
    'isTicketSelectionCompactSizeFlow' | 'isAppRebrandActive'
> & { widgetParentUrl?: string } => ({
    isAppRebrandActive: getIsAppRebrandActive(state),
    isTicketSelectionCompactSizeFlow:
        getIsTicketSelectionCompactSizeFlow(state),
    widgetParentUrl: getWidgetParentUrl(state),
});

const _mapDispatchToProps = <Action>(_dispatch: Dispatch<Action>) => ({});

export type ConnectedProps = Pick<
    TicketDisplayCardContentSwitcherProps,
    | keyof ReturnType<typeof _mapStateToProps>
    | keyof ReturnType<typeof _mapDispatchToProps>
>;

export const connectTicketDisplayCardContentSwitcher = connect(
    _mapStateToProps,
    _mapDispatchToProps,
);
